import { postJson } from "./http";

export interface TallyCurrencyRow {
  code: string;
  name: string;
  symbol: string;
  is_base: boolean;
}

export interface TallyCurrencyChoice {
  code: string;
  name: string;
  symbol?: string;
}

export interface TallyCurrencyPending {
  code: string;
  status: "pending" | "failed";
  error: string | null;
}

export interface TallyCurrencyState {
  currencies: TallyCurrencyRow[];
  available: TallyCurrencyChoice[];
  pending: TallyCurrencyPending[];
}

export interface TallyBankRow {
  name: string;
  account_type: string;
  account_number: string;
  currency_code: string;
  guid: string | null;
}

export interface TallyBankPending {
  name: string;
  status: "pending" | "failed";
  error: string | null;
}

export interface TallyBankState {
  banks: TallyBankRow[];
  currencies: TallyCurrencyChoice[];
  pending: TallyBankPending[];
}

interface DataEnvelope<T> {
  data: T;
}

const currencyState = (publicId: string) =>
  postJson<DataEnvelope<TallyCurrencyState>>("/api/onboarding/tally/currencies/state", { public_id: publicId }).then((r) => r.data);

const createCurrency = (publicId: string, currencyCode: string) =>
  postJson<DataEnvelope<TallyCurrencyState>>("/api/onboarding/tally/currencies/create", {
    public_id: publicId,
    currency_code: currencyCode,
  }).then((r) => r.data);

const bankState = (publicId: string) =>
  postJson<DataEnvelope<TallyBankState>>("/api/onboarding/tally/banks/state", { public_id: publicId }).then((r) => r.data);

const createBank = (
  publicId: string,
  fields: { name: string; account_type: string; account_number: string; currency_code: string }
) =>
  postJson<DataEnvelope<TallyBankState>>("/api/onboarding/tally/banks/create", { public_id: publicId, ...fields }).then((r) => r.data);

export const tallyBooksApi = { currencyState, createCurrency, bankState, createBank };
